/* ============================================================
   MDM Break Bread offer PDP — all page JS, one file, vanilla, defer.
   Sections register themselves via [data-mdm-section]; each keeps its
   own AbortController so Theme Editor section reloads re-init cleanly.
   ============================================================ */
(function () {
  'use strict';

  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduced = function () { return !!(RM && RM.matches); };

  /* ---------- shared offer state (hero + closing + sticky) ---------- */
  var Store = {
    data: null,
    size: null,
    variantId: null,
    bundle: 1,
    subs: [],
    on: function (fn) { this.subs.push(fn); },
    emit: function () { for (var i = 0; i < this.subs.length; i++) { try { this.subs[i](this); } catch (e) {} } },
    variant: function () {
      if (!this.data) return null;
      var v = this.data.variants;
      for (var i = 0; i < v.length; i++) if (v[i].id === this.variantId) return v[i];
      return null;
    },
    tier: function () {
      if (!this.data) return null;
      var b = this.data.bundles;
      for (var i = 0; i < b.length; i++) if (b[i].n === this.bundle) return b[i];
      return b[0];
    },
    setSize: function (size) {
      if (!this.data) return;
      var v = this.data.variants;
      for (var i = 0; i < v.length; i++) {
        if (v[i].size === size && v[i].available) { this.size = size; this.variantId = v[i].id; this.emit(); return; }
      }
      for (var j = 0; j < v.length; j++) {
        if (v[j].size === size) { this.size = size; this.variantId = v[j].id; this.emit(); return; }
      }
    },
    setBundle: function (n) { this.bundle = n; this.emit(); }
  };
  window.MDMOffer = Store;

  /* ---------- money ---------- */
  function fm(cents, fmt) {
    if (cents == null || isNaN(cents)) return '';
    fmt = fmt || '${{amount}}';
    function num(n, dec, thou, places) {
      n = (n / 100).toFixed(places);
      var p = n.split('.');
      var i = p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return places ? i + dec + p[1] : i;
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var val;
    switch (key) {
      case 'amount_no_decimals': val = num(cents, '.', ',', 0); break;
      case 'amount_with_comma_separator': val = num(cents, ',', '.', 2); break;
      case 'amount_no_decimals_with_comma_separator': val = num(cents, ',', '.', 0); break;
      case 'amount_with_apostrophe_separator': val = num(cents, '.', "'", 2); break;
      default: val = num(cents, '.', ',', 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
  }
  function money(cents) { return fm(cents, Store.data && Store.data.moneyFormat); }

  /* ---------- generic rails: nudge buttons + slow auto-drift ---------- */
  var drifts = [];
  var driftRAF = null;
  function driftTick() {
    driftRAF = null;
    var live = false;
    for (var i = 0; i < drifts.length; i++) {
      var d = drifts[i];
      if (!d.el.isConnected) continue;
      live = true;
      if (d.paused || !d.visible) continue;
      var max = d.el.scrollWidth - d.el.clientWidth;
      if (max <= 1) continue;
      d.pos += d.speed * d.dir;
      if (d.pos >= max) { d.pos = max; d.dir = -1; }
      else if (d.pos <= 0) { d.pos = 0; d.dir = 1; }
      d.el.scrollLeft = d.pos;
    }
    if (live) driftRAF = requestAnimationFrame(driftTick);
  }
  function ensureDrift() { if (!driftRAF && drifts.length) driftRAF = requestAnimationFrame(driftTick); }

  function initRail(rail, signal) {
    var prev = rail.parentNode.querySelector('[data-mdm-prev]');
    var next = rail.parentNode.querySelector('[data-mdm-next]');
    var step = function () { return Math.max(200, Math.round(rail.clientWidth * 0.8)); };
    function nudge(dir) {
      var d = drifts.filter(function (x) { return x.el === rail; })[0];
      rail.scrollBy({ left: dir * step(), behavior: reduced() ? 'auto' : 'smooth' });
      if (d) { d.paused = true; setTimeout(function () { if (d) { d.pos = rail.scrollLeft; d.paused = false; } }, 900); }
    }
    if (prev) prev.addEventListener('click', function () { nudge(-1); }, { signal: signal });
    if (next) next.addEventListener('click', function () { nudge(1); }, { signal: signal });

    var speed = parseFloat(rail.getAttribute('data-mdm-drift'));
    if (!speed || reduced()) return;
    var d = { el: rail, speed: speed, dir: 1, paused: false, visible: false, pos: rail.scrollLeft };
    drifts.push(d);
    var pause = function () { d.paused = true; };
    var resume = function () { d.pos = rail.scrollLeft; d.paused = false; };
    rail.addEventListener('mouseenter', pause, { signal: signal });
    rail.addEventListener('mouseleave', resume, { signal: signal });
    rail.addEventListener('touchstart', pause, { passive: true, signal: signal });
    rail.addEventListener('touchend', resume, { passive: true, signal: signal });
    rail.addEventListener('focusin', pause, { signal: signal });
    rail.addEventListener('scroll', function () { if (d.paused) d.pos = rail.scrollLeft; }, { passive: true, signal: signal });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        d.visible = es[0].isIntersecting;
        if (d.visible) { d.pos = rail.scrollLeft; ensureDrift(); }
      }, { threshold: 0 });
      io.observe(rail);
      signal.addEventListener('abort', function () { io.disconnect(); });
    } else { d.visible = true; }
    signal.addEventListener('abort', function () {
      drifts = drifts.filter(function (x) { return x !== d; });
    });
    ensureDrift();
  }

  /* ---------- chip group helper (single-select, aria-pressed) ---------- */
  function chipGroup(root, sel, onPick, signal) {
    var btns = root.querySelectorAll(sel);
    for (var i = 0; i < btns.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          for (var j = 0; j < btns.length; j++) btns[j].setAttribute('aria-pressed', btns[j] === btn ? 'true' : 'false');
          onPick(btn);
        }, { signal: signal });
      })(btns[i]);
    }
    return btns;
  }

  /* ---------- add to cart ---------- */
  var adding = false;
  function addToCart(btn, root) {
    var redirectOnBundle = !!(root && root.hasAttribute('data-mdm-bundle-redirect'));
    var singleToCheckout = !!(root && root.hasAttribute('data-mdm-single-checkout'));
    if (adding || !Store.variantId) return;
    var v = Store.variant();
    if (v && !v.available) return;
    adding = true;
    var added = false;
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    /* Offers 2 and 3 are links to the catalogue now, so the button only ever
       adds this one item. The code is parked by the link, not by the CTA. */
    
       
var qty = 1;
var code = '';

var bsubWidget = document.querySelector('[data-bsub-widget]');
var sellingPlanInput = bsubWidget
  ? bsubWidget.querySelector('[data-bsub-selling-plan-id-input]')
  : null;

var selectedPurchaseOption = bsubWidget
  ? bsubWidget.querySelector('[data-bsub-selling-plan-group-input]:checked')
  : null;

var selectedSellingPlanId = null;

if (
  selectedPurchaseOption &&
  selectedPurchaseOption.value !== 'once' &&
  sellingPlanInput &&
  sellingPlanInput.value
) {
  selectedSellingPlanId = sellingPlanInput.value;
}

var cartItem = {
  id: Store.variantId,
  quantity: qty
};

if (selectedSellingPlanId) {
  cartItem.selling_plan = Number(selectedSellingPlanId);
}

fetch('/cart/add.js', {
  method: 'POST',
  credentials: 'same-origin',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ items: [cartItem] })
}).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json && res.json.description || 'add failed');
        if (redirectOnBundle && Store.bundle > 1 && Store.data && Store.data.collectionUrl) {
          window.location.href = Store.data.collectionUrl;
          return;
        }
        /* An offer only exists if its code reaches checkout. /discount/CODE
           parks it on the session and forwards, so the customer never has to
           copy anything and cannot lose the deal by missing the field. */
        if (code) {
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
          return;
        }
        /* one item and nothing to upsell: skip the drawer, go and pay */
        if (singleToCheckout && Store.bundle === 1) {
          window.location.href = '/checkout';
          return;
        }
        /* Stay on the page and confirm on the button itself. The shopper is
           mid-browse — the offers send them to the catalogue for more — so
           throwing them at checkout or into a drawer interrupts exactly the
           journey the offers are trying to start. */
        added = true;
        /* The drawer caches its own copy of the cart and only re-fetches when
           that copy is null, so bumping the header count alone left it
           rendering the cart as it stood at the last open: badge 2, drawer
           still listing one tee. Reloading reset the component, which is why
           the item only "appeared" after a refresh. Hand it the fresh cart.

           /cart?view=compare rather than /cart.js because that is the view the
           drawer renders from - it carries the per-line compare-at price that
           /cart.js does not, and the savings line reads it. */
        return fetch('/cart?view=compare', { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var wt = window.wetheme;
            /* count first and on its own: it is the one piece of feedback that
               must survive even where the drawer component is not mounted */
            if (wt && typeof wt.updateCartDrawer === 'function') wt.updateCartDrawer(cart);
            /* then the drawer's own state. Leave it as the shopper left it -
               refreshed in place if open, refreshed silently if closed. */
            if (wt && typeof wt.toggleRightDrawer === 'function') {
              var isOpen = document.body.classList.contains('js-drawer-open-right');
              wt.toggleRightDrawer('cart', isOpen, { cart: cart });
            }
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          });
      })
      .catch(function (e) { if (window.console) console.error('[mdm-offer] add to cart:', e); })
      .then(function () {
        adding = false;
        if (!btn) return;
        btn.disabled = false;
        if (!added) { btn.textContent = label; return; }
        /* confirm, then hand the button back so a second tee can be added */
        var confirmText = (Store.data && Store.data.ctaAdded) || 'Added to cart';
        btn.textContent = confirmText;
        btn.setAttribute('data-mdm-added', '');
        if (btn._mdmRevert) clearTimeout(btn._mdmRevert);
        btn._mdmRevert = setTimeout(function () {
          btn.removeAttribute('data-mdm-added');
          /* re-render rather than restoring the old string: size or offer may
             have changed while the confirmation was showing */
          render();
        }, 2200);
      });
  }

  /* ---------- HERO ---------- */
  function initHero(root, signal) {
    var dataEl = root.querySelector('[data-mdm-data]');
    if (dataEl) {
      try { Store.data = JSON.parse(dataEl.textContent); } catch (e) { Store.data = null; }
    }
    if (Store.data) {
      /* the tier setting is a select, so it arrives as a string */
      Store.bundle = parseInt(Store.data.defaultBundle, 10) || 1;
      var pre = null, first = null;
      for (var i = 0; i < Store.data.variants.length; i++) {
        var v = Store.data.variants[i];
        if (!first && v.available) first = v;
        if (Store.data.selectedVariantId && v.id === Store.data.selectedVariantId) pre = v;
      }
      var start = pre || first || Store.data.variants[0];
      if (start) { Store.size = start.size; Store.variantId = start.id; }

      /* a colour swatch hands the chosen size over in ?mdm-size= so switching
         colourway does not silently reset the buy box back to the first size */
      var carried = null;
      try { carried = new URL(window.location.href).searchParams.get('mdm-size'); } catch (e) {}
      if (carried) {
        for (var c = 0; c < Store.data.variants.length; c++) {
          var cv = Store.data.variants[c];
          if (cv.size === carried && cv.available) { Store.size = cv.size; Store.variantId = cv.id; break; }
        }
      }
    }

    initColorPicker(root, signal);

    chipGroup(root, '[data-mdm-size]', function (btn) { Store.setSize(btn.getAttribute('data-mdm-size')); }, signal);
    chipGroup(root, '[data-mdm-bundle]', function (btn) { Store.setBundle(parseInt(btn.getAttribute('data-mdm-bundle'), 10)); }, signal);

    var cta = root.querySelector('[data-mdm-add]');
    if (cta) cta.addEventListener('click', function () { addToCart(cta, root); }, { signal: signal });

    /* gallery */
    var gal = root.querySelector('[data-mdm-gallery]');
    if (gal) {
      var counter = root.querySelector('[data-mdm-galcount]');
      var pills = root.querySelectorAll('[data-mdm-pill]');
      var total = gal.children.length;
      var sync = function () {
        var idx = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
        if (idx < 0) idx = 0; if (idx > total - 1) idx = total - 1;
        if (counter) counter.textContent = (idx + 1) + ' / ' + total;
        for (var i = 0; i < pills.length; i++) pills[i].setAttribute('aria-current', i === idx ? 'true' : 'false');
      };
      gal.addEventListener('scroll', function () {
        if (gal._t) cancelAnimationFrame(gal._t);
        gal._t = requestAnimationFrame(sync);
      }, { passive: true, signal: signal });
      for (var p = 0; p < pills.length; p++) {
        (function (btn, i) {
          btn.addEventListener('click', function () {
            gal.scrollTo({ left: i * gal.clientWidth, behavior: reduced() ? 'auto' : 'smooth' });
          }, { signal: signal });
        })(pills[p], p);
      }
      sync();
    }

    /* rotating viewer count */
    var viewers = root.querySelector('[data-mdm-viewers]');
    if (viewers && !reduced()) {
      var lo = parseInt(viewers.getAttribute('data-min'), 10) || 17;
      var hi = parseInt(viewers.getAttribute('data-max'), 10) || 35;
      var tpl = viewers.getAttribute('data-tpl') || '[n] people looking at this tee right now';
      var t = setInterval(function () {
        var n = lo + Math.floor(Math.random() * Math.max(1, hi - lo + 1));
        viewers.textContent = tpl.replace('[n]', n);
      }, 4600);
      signal.addEventListener('abort', function () { clearInterval(t); });
    }

    render();
  }

  /* Colour picker. Swatches are plain links, so this only adds two niceties:
     the colour name follows the pointer, and the chosen size rides along. */
  function initColorPicker(root, signal) {
    var el = root.querySelector('[data-mdm-colorpicker]');
    if (!el) return;
    var out = el.querySelector('[data-mdm-colorname]');
    var resting = out ? out.textContent : '';
    var links = el.querySelectorAll('a[data-mdm-color]');

    for (var i = 0; i < links.length; i++) {
      (function (a) {
        if (out) {
          a.addEventListener('mouseenter', function () {
            out.textContent = a.getAttribute('data-mdm-color') || resting;
          }, { signal: signal });
          a.addEventListener('mouseleave', function () { out.textContent = resting; }, { signal: signal });
          a.addEventListener('focus', function () {
            out.textContent = a.getAttribute('data-mdm-color') || resting;
          }, { signal: signal });
          a.addEventListener('blur', function () { out.textContent = resting; }, { signal: signal });
        }
        a.addEventListener('click', function (ev) {
          if (!Store.size || ev.defaultPrevented || ev.button !== 0) return;
          if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
          var u;
          try { u = new URL(a.getAttribute('href'), window.location.href); } catch (e) { return; }
          u.searchParams.set('mdm-size', Store.size);
          ev.preventDefault();
          window.location.href = u.toString();
        }, { signal: signal });
      })(links[i]);
    }
  }


  /* ---------- render shared offer state into every bound node ---------- */
  function render() {
    if (!Store.data) return;
    var d = Store.data;
    var v = Store.variant();
    var tier = Store.tier();
    var unit = v ? v.price : (d.variants[0] ? d.variants[0].price : 0);
    var tierPrice = tier ? tier.price : unit;
    var saved = Math.max(0, unit * (tier ? tier.n : 1) - tierPrice);

    /* size chips */
    var sizeBtns = document.querySelectorAll('[data-mdm-size]');
    for (var i = 0; i < sizeBtns.length; i++) {
      sizeBtns[i].setAttribute('aria-pressed', sizeBtns[i].getAttribute('data-mdm-size') === Store.size ? 'true' : 'false');
    }
    /* a spec row bound to weight follows the chosen size */
    var wEls = document.querySelectorAll('[data-mdm-specweight]');
    if (wEls.length && v && v.weight) {
      for (var w = 0; w < wEls.length; w++) wEls[w].textContent = v.weight;
    }

    /* bundle chips */
    var bBtns = document.querySelectorAll('[data-mdm-bundle]');
    for (var b = 0; b < bBtns.length; b++) {
      bBtns[b].setAttribute('aria-pressed', parseInt(bBtns[b].getAttribute('data-mdm-bundle'), 10) === Store.bundle ? 'true' : 'false');
    }

    /* dynamic tier buttons (closing section mirrors the hero's settings) */
    var dyn = document.querySelectorAll('[data-mdm-bundle-dynamic]');
    for (var y = 0; y < dyn.length; y++) {
      var btn = dyn[y];
      var n = parseInt(btn.getAttribute('data-mdm-bundle'), 10);
      var t = null;
      for (var z = 0; z < d.bundles.length; z++) if (d.bundles[z].n === n) t = d.bundles[z];
      if (!t) { btn.hidden = true; continue; }
      btn.hidden = false;
      var saveN = Math.max(0, unit * t.n - t.price);
      fill(btn, '[data-mdm-btier]', t.label);
      fill(btn, '[data-mdm-bprice]', money(t.price));
      var sv = btn.querySelector('[data-mdm-bsave]');
      if (sv) {
        sv.textContent = saveN > 0 ? 'save ' + money(saveN) : (t.note || '');
        sv.className = 'mdm-bundle-s' + (saveN > 0 ? '' : ' mdm-bundle-s--none');
      }
      var bd = btn.querySelector('[data-mdm-bbadge]');
      if (bd) { bd.textContent = t.badge || ''; bd.hidden = !t.badge; }
    }

    /* live price */
    setAll('[data-mdm-price]', money(tier && tier.n > 1 ? tierPrice : unit));

    /* size note */
    var note = '';
    if (v) {
      if (!v.available) note = v.size + ' is gone — pick another size';
      else if (v.qty != null && v.qty > 0 && v.qty <= (d.lowStock || 10)) note = 'Only ' + v.qty + ' left in ' + v.size;
      else note = d.shipLine || '';
    }
    setAll('[data-mdm-sizenote]', note);

    /* CTA label + sub */
    /* leave a button that is showing its confirmation alone */
    var addBtns = document.querySelectorAll('[data-mdm-add]');
    var ctaLabel = tier && tier.n > 1
      ? (d.ctaBundle || 'Add bundle — {price}').replace('{price}', money(tierPrice))
      : (d.ctaSingle || 'Add to cart — {price}').replace('{price}', money(unit));
    var soldOut = v && !v.available;
    for (var a = 0; a < addBtns.length; a++) {
      if (addBtns[a].disabled && adding) continue;
      /* a button mid-confirmation keeps saying "Added to cart" until its own
         timer restores it — otherwise any re-render wipes the feedback */
      if (addBtns[a].hasAttribute('data-mdm-added')) continue;
      addBtns[a].textContent = soldOut ? (d.soldOutLabel || 'Sold out') : ctaLabel;
      addBtns[a].disabled = !!soldOut;
    }

    var sub;
    if (tier && tier.n > 1) {
      sub = 'You save ' + money(saved) + ' · ' + (d.guaranteeLine || '21-day guarantee · ships in 2–5 days');
    } else {
      sub = d.ctaSubSingle || '';
    }
    setAll('[data-mdm-ctasub]', sub);

    /* multi-tee cards */
    var multi = document.querySelectorAll('[data-mdm-multitee]');
    for (var m = 0; m < multi.length; m++) multi[m].hidden = !(tier && tier.n > 1);
    setAll('[data-mdm-tee1size]', Store.size ? 'Size ' + Store.size : '');

    /* sticky sub-line */
    var stickySub = (tier && tier.n > 1 ? tier.label + ' · ' : '') + (Store.size ? 'Size ' + Store.size : '') + (saved > 0 ? ' · save ' + money(saved) : '');
    setAll('[data-mdm-stickysub]', stickySub);
  }
  function setAll(sel, text) {
    var n = document.querySelectorAll(sel);
    for (var i = 0; i < n.length; i++) n[i].textContent = text;
  }
  function fill(root, sel, text) {
    var n = root.querySelector(sel);
    if (n) n.textContent = text;
  }
  Store.on(render);

  /* ---------- CLOSING ---------- */
  function initClosing(root, signal) {
    chipGroup(root, '[data-mdm-bundle]', function (btn) { Store.setBundle(parseInt(btn.getAttribute('data-mdm-bundle'), 10)); }, signal);
    var cta = root.querySelector('[data-mdm-add]');
    if (cta) cta.addEventListener('click', function () { addToCart(cta, root); }, { signal: signal });
    render();
  }

  /* ---------- STICKY ---------- */
  function initSticky(root, signal) {
    var bar = root.querySelector('[data-mdm-stickybar]');
    if (!bar) return;
    var at = parseInt(root.getAttribute('data-mdm-threshold'), 10) || 780;
    var shown = false;
    var onScroll = function () {
      var want = (window.scrollY || window.pageYOffset || 0) > at;
      if (want !== shown) { shown = want; bar.setAttribute('data-shown', shown ? 'true' : 'false'); }
    };
    window.addEventListener('scroll', onScroll, { passive: true, signal: signal });
    onScroll();
    var cta = bar.querySelector('[data-mdm-add]');
    if (cta) cta.addEventListener('click', function () { addToCart(cta, root); }, { signal: signal });
    render();
  }

  /* ---------- MATCHES ---------- */
  function initMatches(root, signal) {
    var rail = root.querySelector('[data-mdm-rail]');
    if (rail) initRail(rail, signal);
    var line = root.querySelector('[data-mdm-matchline]');
    var cards = root.querySelectorAll('[data-mdm-shoe]');
    chipGroup(root, '[data-mdm-pair]', function (btn) {
      var pair = btn.getAttribute('data-mdm-pair');
      var n = 0;
      for (var i = 0; i < cards.length; i++) {
        var hit = pair === 'all' || cards[i].getAttribute('data-mdm-shoe') === pair;
        cards[i].hidden = !hit;
        if (hit) n++;
      }
      if (line) {
        line.textContent = pair === 'all'
          ? (line.getAttribute('data-all') || (n + ' drops'))
          : n + (n === 1 ? ' drop' : ' drops') + ' built for ' + pair;
      }
      if (rail) { rail.scrollLeft = 0; }
    }, signal);
  }

  /* ---------- UGC (video) ---------- */
  function initUgc(root, signal) {
    var rail = root.querySelector('[data-mdm-rail]');
    if (rail) initRail(rail, signal);

    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var save = !!(conn && (conn.saveData || /^(slow-)?2g$/.test(conn.effectiveType || '') || conn.effectiveType === '3g'));

    var vids = root.querySelectorAll('video[data-mdm-src]');
    if (!vids.length) return;
    var playing = [];

    if (save) {
      for (var s = 0; s < vids.length; s++) vids[s].parentNode.setAttribute('data-saver', '1');
    }

    function load(v) {
      if (v.getAttribute('data-loaded')) return;
      v.setAttribute('data-loaded', '1');
      /* poster is lazy too: an inline poster attribute would download on page
         load even though the rail sits well below the fold. */
      var ps = v.getAttribute('data-mdm-poster');
      if (ps) v.poster = ps;
      v.src = v.getAttribute('data-mdm-src');
    }
    function play(v) {
      if (save) return;
      load(v);
      if (playing.indexOf(v) === -1) {
        while (playing.length >= 2) { var old = playing.shift(); try { old.pause(); } catch (e) {} }
        playing.push(v);
      }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function stop(v) {
      playing = playing.filter(function (x) { return x !== v; });
      try { v.pause(); v.currentTime = 0; } catch (e) {}
    }

    if ('IntersectionObserver' in window) {
      var pre = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { load(e.target); pre.unobserve(e.target); } });
      }, { rootMargin: '200px 0px' });
      var vis = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.45) play(e.target);
          else stop(e.target);
        });
      }, { threshold: [0, 0.45, 0.9] });
      for (var i = 0; i < vids.length; i++) { pre.observe(vids[i]); if (!save) vis.observe(vids[i]); }
      signal.addEventListener('abort', function () { pre.disconnect(); vis.disconnect(); });
    } else {
      for (var k = 0; k < vids.length; k++) load(vids[k]);
    }

    function toggleSound(v) {
      var wasMuted = v.muted;
      var all = document.querySelectorAll('video[data-mdm-src]');
      for (var i = 0; i < all.length; i++) {
        all[i].muted = true;
        var lbl = all[i].parentNode.querySelector('[data-mdm-sound]');
        if (lbl) lbl.textContent = lbl.getAttribute('data-off') || 'Tap for sound';
      }
      if (wasMuted) {
        v.muted = false;
        load(v); play(v);
        var b = v.parentNode.querySelector('[data-mdm-sound]');
        if (b) b.textContent = b.getAttribute('data-on') || 'Sound on';
      }
    }
    for (var n = 0; n < vids.length; n++) {
      (function (v) {
        v.addEventListener('click', function () { toggleSound(v); }, { signal: signal });
        var btn = v.parentNode.querySelector('[data-mdm-sound]');
        if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); toggleSound(v); }, { signal: signal });
        var pb = v.parentNode.querySelector('[data-mdm-playbtn]');
        if (pb) pb.addEventListener('click', function (e) {
          e.stopPropagation();
          v.parentNode.removeAttribute('data-saver');
          save = false; load(v);
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        }, { signal: signal });
      })(vids[n]);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { for (var i = 0; i < playing.length; i++) { try { playing[i].pause(); } catch (e) {} } }
    }, { signal: signal });
  }

  /* ---------- DMs ---------- */
  function initDms(root, signal) {
    var rail = root.querySelector('[data-mdm-rail]');
    if (rail) initRail(rail, signal);
  }

  /* ---------- REVIEWS ---------- */
  function initReviews(root, signal) {
    var cards = root.querySelectorAll('[data-mdm-revtag]');
    chipGroup(root, '[data-mdm-filter]', function (btn) {
      var f = btn.getAttribute('data-mdm-filter');
      for (var i = 0; i < cards.length; i++) {
        var tags = (cards[i].getAttribute('data-mdm-revtag') || '').split(' ');
        cards[i].hidden = !(f === 'all' || tags.indexOf(f) !== -1);
      }
    }, signal);
  }

  /* ---------- boot / re-init ---------- */
  var INITS = {
    hero: initHero, matches: initMatches, ugc: initUgc,
    dms: initDms, closing: initClosing, reviews: initReviews, sticky: initSticky
  };
  var controllers = {};

  function initSection(el) {
    if (!el) return;
    var roots = el.matches && el.matches('[data-mdm-section]') ? [el] : el.querySelectorAll('[data-mdm-section]');
    for (var i = 0; i < roots.length; i++) {
      (function (root) {
        var key = root.getAttribute('data-mdm-id') || root.getAttribute('data-mdm-section');
        if (controllers[key]) controllers[key].abort();
        var ac = new AbortController();
        controllers[key] = ac;
        var fn = INITS[root.getAttribute('data-mdm-section')];
        if (fn) { try { fn(root, ac.signal); } catch (e) { if (window.console) console.error('[mdm-offer]', e); } }
      })(roots[i]);
    }
  }

  function boot() {
    var all = document.querySelectorAll('[data-mdm-section]');
    /* hero first so Store.data exists before the others render */
    for (var i = 0; i < all.length; i++) if (all[i].getAttribute('data-mdm-section') === 'hero') initSection(all[i]);
    for (var j = 0; j < all.length; j++) if (all[j].getAttribute('data-mdm-section') !== 'hero') initSection(all[j]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) { initSection(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var roots = e.target.querySelectorAll ? e.target.querySelectorAll('[data-mdm-section]') : [];
    for (var i = 0; i < roots.length; i++) {
      var key = roots[i].getAttribute('data-mdm-id');
      if (controllers[key]) { controllers[key].abort(); delete controllers[key]; }
    }
  });
})();
